import { CATEGORIES } from 'constants/ChecklistConstants';

/**
 * @typedef {{
 *  category: string,
 *  acceptedAmount: number,
 *  price: number,
 *  [field: string]: any
 * }} Data
 */

/**
 * @param {Array<Data>} allData
 * @returns {Array<Data>}
 */
export const getDiscountedCategoriesInAbsoluteNumber = (allData = []) =>
  allData.map(data => {
    if ([CATEGORIES.DISCOUNT, CATEGORIES.TRADE_IN].includes(data.category)) {
      return { ...data, acceptedAmount: Math.abs(data.acceptedAmount), price: Math.abs(data.price) };
    }
    return data;
  });
